// ! This file was auto-generated from the evisearch OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    getEmbeddingVectorIds: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EmbeddingVectorId, id: "LIST" }]
    },
    getExportOptions: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ExportOption, id: "LIST" }]
    },
    getFilters: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Filter, id: "LIST" }]
    },
    getFilterSuggestions: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FilterSuggestion, id: "LIST" }]
    },
    getSearch: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.SearchResult, id: "LIST" }]
    },
    getSearchAfter: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.SearchResult, id: "LIST" }]
    },
    getSearchExportOptions: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ExportOption, id: "LIST" }]
    },
    getVectorSearch: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.VectorSearchResult, id: "LIST" }]
    },
    insertEmbeddingVectorIds: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.EmbeddingVectorId, id: "LIST" }]
    },
    search: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.SearchResult, id: "LIST" }]
    },
    searchAfter: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.SearchResult, id: "LIST" }]
    },
    vectorSearch: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.VectorSearchResult, id: "LIST" }]
    }
} as const;
